import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import Pagination from "react-js-pagination";
import fileDownload from 'js-file-download';

import { loaderEnd, loaderStart } from '../../components/loader';

import { getQuestion } from './api';
import Question from "./eachQuestion";
import '../Question-bank/questionbank.css'
import './styles.css'

const limit = 100;

const Questions = () => {
    const { ...params } = useParams()
    const [questions, setQuestions] = useState([])
    const [pageNo, setPageNo] = useState(0)
    const [total, setTotal] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [topicName, setTopicName] = useState('')

    useEffect(() => {
        getData()
    }, [pageNo])

    const getData = async () => {
        loaderStart()
        let res = await getQuestion(pageNo, params.topic);
        if (res) {
            setQuestions(res.data.questions)
            setTotal(res.data.count)
            if (res.data.topic_name) setTopicName(res.data.topic_name)
        }
        setLoaded(true)
        loaderEnd()
        // Paging previously left the reader wherever they were scrolled, so
        // page 2 opened halfway down its own list. Guarded because not every
        // environment implements scrollTo (jsdom in tests, older webviews).
        if (typeof window.scrollTo === 'function') {
            try { window.scrollTo({ top: 0, behavior: 'smooth' }) } catch (e) { /* no-op */ }
        }
    }

    const exportData = async () => {
        loaderStart()
        let res = await getQuestion(pageNo, params.topic, true);
        let fileName = params.topic + Date.now() + '.pdf';
        fileDownload(res, fileName);
        loaderEnd()
    }

    const handleSelected = (page) => {
        setPageNo(page - 1)
    }

    const firstOnPage = pageNo * limit + 1
    const lastOnPage = Math.min((pageNo + 1) * limit, total)

    return (
        <div className='qb_page'>
            <nav className='qb_crumbs'>
                <Link to='/question-bank'>Question Bank</Link>
                <span className='qb_crumb_sep'>/</span>
                <span>{topicName || 'Questions'}</span>
            </nav>

            <div className='qb_questions_head'>
                <div>
                    <h1 className='qb_title'>Questions</h1>
                    <p className='qb_subtitle'>
                        {topicName ? <b>{topicName}</b> : null}
                        {topicName && total > 0 ? ' · ' : ''}
                        {total > 0
                            ? `Showing ${firstOnPage}–${lastOnPage} of ${total} · correct answer highlighted`
                            : ''}
                    </p>
                </div>

                <button type='button' className='qb_download' onClick={exportData}>
                    <i className='fa fa-download' aria-hidden='true'></i>
                    Download PDF
                </button>
            </div>

            {questions.length > 0 ? (
                <>
                    <ol className='qb_question_list'>
                        {questions.map((q, i) => (
                            <Question
                                question={q}
                                index={(i + 1) + (pageNo * limit)}
                                key={q.mcq_id || i}
                            />
                        ))}
                    </ol>

                    {total > limit ? (
                        <div className='qb_pagination'>
                            <Pagination
                                activePage={pageNo + 1}
                                itemsCountPerPage={limit}
                                totalItemsCount={total}
                                pageRangeDisplayed={3}
                                onChange={handleSelected}
                                itemClass="page-item"
                                linkClass="page-link"
                            />
                        </div>
                    ) : null}
                </>
            ) : loaded ? (
                <p className='qb_empty'>No questions are available for this chapter yet.</p>
            ) : null}
        </div>
    )
}

export default Questions
